import { combineReducers } from '@reduxjs/toolkit';
import uploadReducer from '../upload';
import signatureWizardReducer from '../signatures/signature-wizard';
import layoutReducer from '../layout';
import crossProductActionReducer from '../crossProductAction';

const rootReducer = combineReducers({
  upload: uploadReducer,
  layout: layoutReducer,
  signatureWizard: signatureWizardReducer,
  crossProductAction: crossProductActionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
